(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["puffit-faq-widget"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getRoots = (scope) => {
      if (scope && scope.matches && scope.matches('[data-faq-root]')) return [scope];
      return [...(scope || document).querySelectorAll('[data-faq-root]')];
    };

    const init = (scope) => getRoots(scope).filter((root) => root.dataset.faqInitialized !== 'true').forEach((root) => {
      root.dataset.faqInitialized = 'true';
      const searchForm = root.querySelector('[data-faq-search-form]');
      const searchInput = root.querySelector('[data-faq-search]');
      const menuButtons = [...root.querySelectorAll('.faq-widget__menu-button')];
      const items = [...root.querySelectorAll('.faq-item')];
      const resultCount = root.querySelector('[data-faq-results]');
      const emptyState = root.querySelector('[data-faq-empty]');
      const expandButton = root.querySelector('[data-faq-expand]');
      const faqList = root.querySelector('[data-faq-list]');
      const openAllLabel = root.dataset.openAll;
      const closeAllLabel = root.dataset.closeAll;
      const answerWord = root.dataset.answerWord;
      const answersWord = root.dataset.answersWord;
      const searchAliases = {
        brand: 'brand about mission everyday outdoor 品牌 品牌故事 使命 户外 通勤',
        technology: 'technology fabric material waterproof breathable windproof stain resistant care 技术 科技 材质 面料 防水 透气 防风 防污 洗护',
        shipping: 'shipping delivery dispatch track order 配送 物流 发货 订单 运输',
        returns: 'returns exchange refund quality issue 退货 换货 退款 质量问题',
        promotions: 'promotion free gift cart gift 促销 赠品 礼物 优惠',
        products: 'product jacket rain coat size temperature season layering material 产品 夹克 外套 尺码 温度 季节 叠穿 材质 面料',
        payment: 'payment card paypal checkout secure 支付 银行卡 结账 安全',
        service: 'service support contact help 客服 支持 联系 帮助',
        tax: 'tax customs import duty DDP 税费 海关 进口 关税',
      };
      let activeCategory = 'all';

      const applyFilters = () => {
        const query = searchInput.value.trim().toLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const categoryMatches = activeCategory === 'all' || item.dataset.category === activeCategory;
          const searchText = `${item.textContent} ${searchAliases[item.dataset.category] || ''}`.toLowerCase();
          const queryMatches = query === '' || searchText.includes(query);
          const visible = categoryMatches && queryMatches;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        resultCount.textContent = `${visibleCount} ${visibleCount === 1 ? answerWord : answersWord}`;
        emptyState.hidden = visibleCount !== 0;
        expandButton.textContent = openAllLabel;
      };

      menuButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeCategory = button.dataset.category;
          menuButtons.forEach((menuButton) => menuButton.setAttribute('aria-pressed', String(menuButton === button)));
          applyFilters();
          if (window.matchMedia('(max-width: 640px)').matches) {
            faqList.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      searchInput.addEventListener('input', applyFilters);
      searchForm.addEventListener('submit', (event) => event.preventDefault());

      expandButton.addEventListener('click', () => {
        const visibleItems = items.filter((item) => !item.hidden);
        const shouldOpen = visibleItems.some((item) => !item.open);
        visibleItems.forEach((item) => {
          item.open = shouldOpen;
        });
        expandButton.textContent = shouldOpen ? closeAllLabel : openAllLabel;
      });

      applyFilters();
    });

    const boot = () => init(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:reorder', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puffit-hero"] && !Shopify.designMode) return;
  try {
    
  // 视频开始播放后，淡出外部 poster 层，避免黑屏/封面残留
  (function() {
    var medias = document.querySelectorAll('[data-hero-media]');
    medias.forEach(function(wrap) {
      var poster = wrap.querySelector('.puffit-hero__poster');
      if (!poster) return;
      var video = wrap.querySelector('video');
      if (!video) return;

      var hidePoster = function() {
        poster.style.opacity = '0';
      };

      video.addEventListener('playing', hidePoster, { once: true });
      if (video.readyState >= 2 && !video.paused) hidePoster();
      wrap.addEventListener('video:playing', hidePoster);
    });
  })();

  // 监听Shopify标准弹窗/抽屉事件，给body添加标记，触发上移动画
  document.addEventListener('shopify:modal-open', () => document.body.classList.add('popup-open'));
  document.addEventListener('shopify:modal-close', () => document.body.classList.remove('popup-open'));
  document.addEventListener('shopify:drawer-open', () => document.body.classList.add('drawer-open'));
  document.addEventListener('shopify:drawer-close', () => document.body.classList.remove('drawer-open'));

  } catch(e) { console.error(e); }
})();
})();
